<template>
	<div class="mt-2">
		<!-- dialog price -->
		<v-dialog
			v-model="dialogPriceType"
			persistent
			width="400"
			@keydown.esc="dialogPriceType = false"
		>
            <v-card>
                <div class="d-flex py-1 primary">
                    <v-card-title
                        class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
                    >
                        {{ $t('add-prices-for-an-item') }}
                    </v-card-title>

                    <v-btn icon @click="dialogPriceType = false">
                        <v-icon color="white"> mdi-close-circle-outline </v-icon>
                    </v-btn>
                </div>

                <v-card-text>
                    <v-row class="mt-3">
                        <p class="mb-2">
                            {{ $t('please-enter-the-type-price-for-this-item', { type: pricesTypes.find(c => c.id === tableInputs.priceType)?.name }) }}
                        </p>
                        <v-col 
                            sm="6" 
                            cols="12" 
                            class="pa-1"
                        >
                            <v-text-field
                                v-model.number="price"
                                clearable
                                outlined
                                dense
                                hide-details="auto"
                                :label="$t('inputs.price')"
                                :loading="submitLoading"
                                :disabled="submitLoading"
                                :rules="rules.requiredAsNumber"
								autofocus
                            />
                        </v-col>

                        <v-col 
                            sm="6" 
                            cols="12" 
                            class="pa-1"
                        >
                            <v-text-field 
                                v-model.number="priceDiscountRate"
                                clearable
                                outlined
                                dense
                                hide-details="auto"
                                :label="$t('inputs.discount-rate')"
                                :disabled="submitLoading"
                                :rules="rules.requiredAsNumber"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-end pt-0">
                    <v-btn
                        color="success"
                        text
                        :loading="submitLoading"
                        @click="updateItemPrice()"
                    >
                        {{$t('save')}}
                    </v-btn>
                    <v-btn
                        @click="dialogPriceType = false"
                        text
                        :disabled="submitLoading"
                    >
                        {{$t('cancel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
		<!-- dialog -->
		<v-dialog
			width="400"
			v-model="dialog"
			persistent
			@keydown.esc="dialog = false"
		>
			<v-card>
				<div class="d-flex primary py-1">
					<v-card-title
						class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
					>
						{{ $t('edit') }}
					</v-card-title>

					<!-- close button -->
					<v-btn icon @click="dialog = false; $refs.form.resetValidation()">
						<v-icon color="white">
							mdi-close-circle-outline
						</v-icon>
					</v-btn>
				</div>
				<v-form ref="form" @submit.prevent="editItem">
					<v-card-text class="">
						<v-row>
							<v-col cols="12" sm="12" class="py-1">
								<v-autocomplete
									v-model="sampleData.accountId"
									:items="allAccountsBrief.filter(c => c.id !== employeeId)"
									item-value="accountId"
									item-text="name"
									:disabled="submitLoading"
									:label="$t('inputs.account')"
									outlined
									dense
									hide-details
									autofocus
									:rules="rules.required"
								></v-autocomplete>
							</v-col>

							<v-col cols="12" sm="6" class="py-1">
								<v-autocomplete
									v-model="sampleData.materialsAmount.materialId"
									:items="myMaterials"
									item-value="id"
									:item-text="(item) => `${item.remaining} - ${item.name}`"
									:label="$t('inputs.item')"
									outlined
									dense
									hide-details
									:disabled="submitLoading"
									:rules="rules.required"
								></v-autocomplete>
							</v-col>

							<v-col cols="12" sm="6" class="py-1">
								<v-text-field
									v-model.number="sampleData.materialsAmount.amount"
									:label="$t('inputs.amount')"
									outlined
									dense
									hide-details
									:disabled="submitLoading"
									:rules="rules.requiredAsNumber"
								/>
							</v-col>

							<v-col v-if="addPrice" cols="12" sm="6" class="py-1">
								<v-text-field
									v-model.number="sampleData.materialsAmount.sellPrice"
									:label="$t('inputs.price')"
									outlined
									dense
									hide-details
									:disabled="submitLoading || this.entityTab === 0"
								/>
							</v-col>

							<v-col v-if="addPrice" cols="12" sm="6" class="py-1">
								<v-autocomplete
									v-model.number="sampleData.payment"
									:label="$t('inputs.payment-method')"
									:items="paymentMethods"
									item-text="name"
									item-value="id"
									outlined
									dense
									hide-details
									:disabled="submitLoading || this.entityTab === 0"
								/>
							</v-col>

							<v-col cols="12" sm="12" class="py-1">
								<v-text-field
									v-model="sampleData.description"
									:label="$t('inputs.notes')"
									outlined
									dense
									hide-details
									:disabled="submitLoading"
								/>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-spacer />
						<v-btn color="success" small type="submit" :loading="submitLoading">
							{{$t('save')}}
						</v-btn>

						<v-btn color="alert-color white--text" small @click="dialog = false" :disabled="submitLoading">
							{{$t('cancel')}}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<!-- delete dialog declaered here to use it as ref -->
        <delete-dialog
            ref="deleteDialog"
            :success-message="$t('message.data-is-deleted')"
            @on-delete="getStatement"
        >
			{{ $t('are-you-sure-you-want-to') }} {{$t('delete')}} {{$t('JournalItems.this-transfer') + $t('?') }}
        </delete-dialog>
		<v-row dense align="center">
			<!-- filter -->
			<v-col order-sm="0" order="1" md="3" sm="4" cols="12">
				<bee-date-input
					v-model="date"
					:label="$t('inputs.date')"
					dense
					:disabled="loading"
					input-format-order="DD-MM-YYYY"
					hide-details
					:append-icon="$i18n.locale === 'en' ? 'mdi-menu-right' : 'mdi-menu-left'"
					:prepend-icon="$i18n.locale === 'en' ? 'mdi-menu-left' : 'mdi-menu-right'"
					@click:append="
                        needToResetShownRows = true;
                        date = moment(date).add(1, 'day').format('YYYY-MM-DD');
                        getJournal(null, null);
                    "
					@click:prepend="
                        needToResetShownRows = true;
                        date = moment(date).subtract(1, 'day').format('YYYY-MM-DD')
                        getJournal(null, null);
                    "
				></bee-date-input>
			</v-col>

			<v-col v-if="entityTab === 1" md="2">
				<v-autocomplete 
					v-model="entity"
					:items="customersTypes"
					item-text="name"
					item-value="id"
					:label="$t('inputs.type')"
					outlined
					dense
					hide-details
					:disabled="loading || submitLoading"
					:loading="loading || submitLoading"
				/>
			</v-col>

			<!-- entityTab === 1 city region filter -->
            <v-col v-if="0" lg="3" md="5" sm="7" cols="12" class="pa-1">
                <v-row class="pa-3 pa-3 d-flex justify-space-between">
                    <!-- cities -->
                    <v-col cols="5" class="pa-0 pe-1 d-flex">
                        <v-icon class="me-2" size="28"> mdi-map-marker-multiple </v-icon>
                        <v-autocomplete
                            v-model="cityId"
                            :items="cities"
                            item-text="name"
                            item-value="id"
                            :label="$t('inputs.city')"
                            dense
                            hide-details
                            append-icon
                            @change="setRegions(); searchCityId = null"
                            :disabled="loading"
                            outlined
                            multiple
                            :search-input.sync="searchCityId"
                        >
                            <template v-slot:prepend-item>
                                <v-list-item
                                    ripple
                                    @click="toggleCities"
                                >
                                    <v-list-item-action>
                                        <v-icon>
                                            {{ iconCities }}
                                        </v-icon>
                                    </v-list-item-action>
                                    
                                    <v-list-item-content>
                                        <v-list-item-title>
                                           {{$t('select-all')}}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>

                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                <span
                                    v-if="index === 1"
                                    class="grey--text text-caption"
                                >
                                    (+{{ cityId.length - 1 }})
                                </span>
                            </template>   
                        </v-autocomplete>
                    </v-col>

                    <!-- region -->
                    <v-col v-if="0" cols="7" class="pa-0">
                        <v-autocomplete
                            v-model="regionIds"
                            :items="regionsAll.filter(c => cityId.includes(c.cityId))"
                            item-text="name"
                            item-value="id"
                            :label="managementHierarchyRegions ? 'Areas' : 'Regions'"
                            dense
                            multiple
                            clearable
                            hide-details
                            :loading="regionsLoading"
                            :disabled="loading || regionsLoading || cityId === []"
                            outlined
                            :search-input.sync="searchRegionId"
                            @change="searchRegionId = null"
                        >
                            <template v-slot:prepend-item v-if="regions">
                                <v-list-item ripple @click="toggleReignsFilterItems">
                                    <v-list-item-action>
                                        <v-icon>
                                            {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{$t('select-all')}}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" class="me-1">{{ item.name }}</span>
                                <span
                                    v-if="index === 1"
                                    class="grey--text text-caption"
                                >
                                    (+{{ regionIds.length - 1 }})
                                </span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>

			<v-col v-if="entityTab === 1" class="pt-0 pb-1">
				<v-btn
					@click="search()"
					color="success white--text"
					small
					:disabled="loading"
					:loading="loading || submitLoading"
				>
					{{$t('search')}} 
				</v-btn>
			</v-col>
			<v-spacer/>

			<!-- remaining -->
			<v-col sm="auto" cols="12" class="text-end">
				<v-btn
					v-if="isSuperAdmin || permissionsUser.MaterialTransactions !== roleName.nothing"
					small
					:to="{ 
						name: 'supervisor-remaining-samples',
						query: { from: 'delivery' }
					}"
					color="light-blue white--text"
				>
					{{$t('JournalDeliveryOfSamples.remaining-samples')}}
				</v-btn>
			</v-col>
		</v-row>

		<!-- type tabs -->
		<v-tabs
			v-model="entityTab"
			height="40"
			@change="$nextTick( () => { $refs.table.resetInputs({ date: moment().format('YYYY-MM-DD') }) }); existType = false; resetFilter(); updateTableDueTab()"
		>
			<v-tab
				v-for="item in types"
				:key="item.id"
				:disabled="loading"
			>
				{{item.name}}
			</v-tab>
		</v-tabs>
		<v-divider class="mb-2"/>

		<!-- deliver / receive tabs -->
		<v-tabs
			v-if="entityTab === 0"
			v-model="tab"
			height="30"
			active-class="secondary lighten-1 white--text overflow-hidden rounded-t"
			@change="needToResetShownRows = true; getJournal(null, null)"
		>
			<v-tab :disabled="loading" @click="getMaterialByAccountd()">
				{{$t('JournalDeliveryOfSamples.deliver')}}
			</v-tab>
			<v-tab :disabled="loading">{{$t('JournalDeliveryOfSamples.receive')}}</v-tab>
			<v-tabs-slider color="secondary lighten-1"></v-tabs-slider>
		</v-tabs>

     	<bee-handy-smart-table
			v-model="tableInputs"
			ref="table" 
			:headers="headers"
			:items="[]"
			:show-add-row="(
				(entityTab !== 1 || existType) && permissionsUser.MaterialTransactions !== roleName.read && !loading
			) || 
			(isSuperAdmin && (entityTab !== 1 || existType) && !loading)"
			:loading="loading"
			:items-per-page="50"
			hide-default-footer 
			dense
			zebra
			:disable-input-fields="loading"
            fixed-head
            :height="((entityTab !== 1 || existType) && permissionsUser.MaterialTransactions !== roleName.read )|| (isSuperAdmin && entityTab !== 1 || existType) ? $vuetify.breakpoint.height - ($vuetify.breakpoint.smAndUp ? 210 : 250) : '70' "
            :scroll-options.sync="scrollOptions"
            pagination-on-scroll
            pagination-on-scroll-server-items
			hide-inputs-details
            :server-items-length="serverItemsLength"
			@keypress.enter="addItem"
            @pagination-on-scroll:reach-last-row="getJournal"
			@change-freeSample="resetInputsPrices"
            @change-materialId="changeOnChangeMaterial"
            @change-priceType="getPriceValue"
			@change-accountId="getMaterialByAccount()"
            @change-priceDiscount="updatePrice"
            @change-sellPrice="updateX"
            @input-sellPrice="tableInputs.priceDiscount = 0; customPrice = true"
			:shown-rows-text="$t('shown-rows')"
			hot-inputs
		>
            <!-- accounts -->
			<template v-slot:input.accountId="{ attr, on }">
				<v-autocomplete
					:items="entityTab === 1 ? customers.filter(c => c.typeId === entity) : staff?.filter(c => c.id !== employeeId)"
					:item-value="entityTab !== 1 ? 'accountId' : 'name'"
					:item-text="(item) => (includeAddressWithCustomers && entityTab !== 0) ? `${item.name} - ${item.address ? item.address : '-'}` : `${item.name}`"
					:readonly="materialLoading"
					v-on="on"
					v-bind="attr"
				></v-autocomplete>
			</template>

			<!-- product name -->
			<template v-slot:input.materialId="{ attr, on }">
				<v-autocomplete
					:items="myMaterials"
					item-value="id"
					:item-text="(item) =>`${item.remaining} - ${item.name} `"
					:readonly="materialLoading"
					v-bind="attr"
					v-on="on"
				></v-autocomplete>
			</template>

			<template v-slot:input.date="{ on, attr }">
				<v-menu
					ref="dateInputTable"
					v-model="dateInputTable"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="tableInputs.date"
							clearable
							type="date"
							v-on="on"
							v-bind="attr"
						>
							<template v-slot:prepend>
								<v-icon
									v-bind="attrs"
									v-on="on"
								>
									mdi-calendar
								</v-icon>
							</template>
						</v-text-field>
					</template>
					<v-date-picker
						v-model="tableInputs.date"
						:active-picker.sync="activePickerDate"
						:max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
						min="1940-01-01"
						:allowed-dates="disableDates"
						@change="saveDate"
					></v-date-picker>
				</v-menu>
			</template>

			<template v-if="addPrice" v-slot:input.freeSample="{ on, attr }">
                <v-checkbox 
                    v-model="tableInputs.freeSample"
                    dense
                    hide-details
                    v-on="on"   
                    v-bind="attr"
                />
            </template>

			<template v-if="addPrice" v-slot:item.freeSample="{ item }">
                <v-chip small>
                    <span :class="item.freeSample === true ? 'primary--text' : 'paid-color-text'">
                        {{ item.freeSample === true ? 'Free' : 'Paid' }}
                    </span>
                </v-chip>
            </template>

            <template v-if="addPrice"  v-slot:input.priceDiscount="{ on, attr }">
                <v-text-field 
                    dense
                    hide-details
                    v-on="on"
                    v-bind="attr"
                    prefix="%"
                    :disabled="disabledDiscount || tableInputs.freeSample"
                />
            </template>

			<template v-if="addPrice" v-slot:input.payment="{ on, attr }">
				<v-autocomplete 
					:items="paymentMethods"
					item-text="name"
					item-value="id"
					v-bind="attr"
					v-on="on"
					:disabled="tableInputs.freeSample === true"
				/>
			</template>

			<template v-if="addPrice" v-slot:input.priceType="{ on, attr }">
                <v-autocomplete 
                    :items="pricesTypes"
                    item-value="id"
                    item-text="name"
                    dense
                    hide-details
                    v-on="on"
                    v-bind="attr"
                />
            </template>

			<template v-slot:item.actions="{ item }">
				<v-btn
					color="success"
					small
					icon
					@click="dialog = true; myItem = item; isEdit = true"
					:disabled="materialLoading || loading"
				>
					<v-icon>mdi-pencil</v-icon>
				</v-btn>

				<v-btn
					color="alert-color"
					small
					icon
					@click="item.linkedTransactionId !== null ? 
					$refs.deleteDialog.activeDeleteDialog(item.id, 'materialTransactions', 'delete') :  
					$refs.deleteDialog.activeDeleteDialog(item.id, 'materialTransactions', 'deleteSingleTransaction')"
					:disabled="materialLoading || loading"
				>
					<v-icon> mdi-delete </v-icon>
				</v-btn>
            </template>

            <template v-slot:no-input.actions>
                <v-btn
                    color="success"
                    small
                    icon
                    :disabled="loading"
                    @click="addItem"
                >
                    <v-icon>mdi-check-circle-outline</v-icon>
                </v-btn>
            </template>
       	</bee-handy-smart-table>

		<div
			v-if="!existType && entityTab === 1"
			class="d-flex flex-column justify-center align-center"
            :style="{ height: `${$vuetify.breakpoint.height - 300}px` }"
		>
			<template >
				<v-icon size="60" class="mb-1">mdi-invoice-list</v-icon>
				<span class="text-h6">{{$t('SamplesStatement.please-select-a-filter')}}</span>
			</template>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DeleteDialog from '@/components/DeleteDialog'
import { roleName, paymentMethods } from '@/helpers/enums'
import moment from 'moment'
import rules from '@/validation rules'
import { managementHierarchyRegions, addPrice, enableFreeDistributionWithPrice, includeAddressWithCustomers, isDisabledFriday, enablePricesTypes, enableDiscount, isIntNumberRule, enableCustomerType } from '@/configs/global.config'
import { disableDates } from '@/helpers/functions'

export default {
	name: 'JournalDeliveryOfSamples',
	components: {
		DeleteDialog
	},
	watch: {
		dialog (val) {
			if (val) {
				this.sampleData.materialsAmount.materialId = this.myItem.materialId
				this.sampleData.accountId = this.myItem.accountId
				this.sampleData.materialsAmount.amount = this.myItem.in !== null ? this.myItem.in.amount : this.myItem.out.amount
				this.sampleData.description = this.myItem.description
				this.itemId = this.myItem.id
				this.sampleData.date = this.myItem.date
				this.sampleData.type = this.myItem.transactionType
				if (this.addPrice) {
					this.sampleData.materialsAmount.sellPrice = this.myItem.sellPrice ? this.myItem.sellPrice : 0
					this.sampleData.payment = this.myItem.payment
				} 
			} else {
				this.sampleData.materialsAmount.materialId = null
				this.sampleData.accountId = null
				this.sampleData.materialsAmount.amount = null
				this.sampleData.description = null
				this.itemId = null
				this.sampleData.date = null
				this.sampleData.type = null
				
				if (this.addPrice) {
					this.sampleData.materialsAmount.sellPrice = 0
					this.sampleData.payment = null
				}
				this.isEdit = false
			}
		},

		entity(val) {
			if (val === null) {
				this.existType = false
			}
		},

		dateInputTable (val) {
            val && setTimeout(() => (this.activePickerDate))
        },

		dialogPriceType (val) {
            if (!val) {
                this.price = 0
                this.priceDiscountRate = 0
            }
        }
	},

    data () {
        return {
			cityId: [],
            searchCityId: null,
			regionIds: [],
			regionsLoading: false,
			searchRegionId: null,

			dialog: false,
			tab: 0,
			entityTab: 0,
			roleName,
            loading: false,
            tableInputs: {
				freeSample: false,
                sellPrice: 0,
				date: moment().format('YYYY-MM-DD')
			},

			date: this.moment().format('YYYY-MM-DD'),
			types: [
                { id: 0, name: this.$t('tabs.staff') },
                { id: 1, name: this.$t('tabs.customers') }
                // { id: 2, name: this.$t('tabs.external') }
            ],
			serverItemsLength: 0,
			scrollOptions: {},

			briefAccounts: [
                [], // for staff
                [], // for customers
                [], // for external
            ],
			
			itemId: null,
			sampleData:{
                materialsAmount:{
                    materialId: null,
                    amount: null,
					sellPrice: 0,
					payment: 0,
					priceDiscount: 0,
					freeSample: false
                },
                accountId: null,
                date: null,
                description: null,
                type: null
            },

			submitLoading: false,
			entity: null,
			existType: false,
			materialLoading: false,
			// addTransactionToEntity: false,
			// staff: [],
			disabledDiscount: false,
			allMaterials: [],
			customPrice: false,
			activePickerDate: null,
            dateInputTable: false,
			// config global 
			managementHierarchyRegions,
			addPrice,
			paymentMethods,
			enableFreeDistributionWithPrice,
			includeAddressWithCustomers,
			isDisabledFriday,
			enablePricesTypes,
			enableDiscount,
			isIntNumberRule,
			enableCustomerType,
			disableDates,
			dialogPriceType: false,
			priceDiscountRate: 0,
			price: 0,
			rules
        }
    },
    computed: {
        ...mapState({
            supervisors: state => state.supervisors.supervisors,
            materials: state => state.materials.materials,
			isSuperAdmin: state => state.auth.isSuperAdmin,
			permissionsUser: state => state.auth.youPermissions,
			myMaterials: state => state.materials.myMaterials,
			cities: state => state.cities.cities,
			regionsAll: state => state.regions.regionsAll,
			regions: state => state.regions.regions,
			pricesTypes: state => state.pricesTypes.pricesTypes,
			employeeId: state => state.auth.self.employeeId,
			customersTypes: state => state.entityType.customersTypes,
			staff: state => state.accounts.staff,
			customers: state => state.accounts.customers
        }),

        ...mapGetters({
            getMaterialById: 'materials/getMaterialById',
            getSupervisorById: 'supervisors/getSupervisorById',
			getAccountById: 'accounts/getAccountById'
        }),
	
        headers () {
            const headers = [
				this.entityTab !== 1 ? {
                    text: this.$t('headers.account'),
                    name: 'accountId',
                    value: 'accountId',
                    setValueExpr: val => this.entityTab === 0 ? this.staff?.find(c => c.accountId === val)?.name : this.allAccountsBrief?.find(c => c.accountId === val)?.name,
                    type: 'string',
					width: this.entityTab !== 0 ? '10%' : '15%',
					sortable: false,
					cellClass: 'px-1',
				} : {
                    text: this.$t('headers.account'),
                    name: 'accountId',
                    value: 'accountName',
                    type: 'string',
					width:  this.entityTab !== 0 ? '10%' : '15%',
					sortable: false,
					cellClass: 'px-1',
				},
                {
                    text: this.$t('headers.item'),
                    name: 'materialId',
                    value: 'materialId',
                    setValueExpr: val => this.myMaterials?.find(c => c.id === val)?.name,
                    type: 'string',
					sortable: false,
					width:  this.entityTab !== 0 ? '10%' : '15%',
					cellClass: 'px-1',
                },
				this.entityTab !== 0 ? {
					text: this.$t('headers.employee'),
                    name: 'fromAccountId',
                    value: 'fromToAccountName',
					// setValueExpr: val => this.staff.length ? this.staff.find(c => c.accountId === val)?.name : 'Loading...',
					noInput: true,
					sortable: false,
					width:  this.entityTab !== 0 ? '10%' : 'auto',
					cellClass: 'px-1',
				} : null,
				enableFreeDistributionWithPrice && addPrice && this.entityTab !== 0
				?	{
						text: this.$t('headers.free'),
						name: 'freeSample',
						value: 'freeSample',
						sortable: false,
						cellClass: 'px-1',
					}
				: null,

				// for prices types and price for this type and discount
                addPrice && enablePricesTypes && this.entityTab !== 0 ? {
                    text: this.$t('headers.price-type'),
                    name: 'priceType',
                    value: 'priceType',
					sortable: false,
					width:  this.entityTab !== 0 ? '10%' : 'auto',
					cellClass: 'px-1',
					disableInput: this.tableInputs.freeSample || 
					!this.tableInputs.materialId
					// (this.tableInputs.materialId && this.myMaterials.find(c => c.id === this.tableInputs.materialId).prices.length === 0)
                }
                : null,
				addPrice && this.entityTab !== 0 ? {
					text: this.$t('headers.sell-price'),
					name: 'sellPrice',
					value: 'sellPrice',
					type: 'number',
					inputRules: this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.length && 
							this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.tableInputs.priceType)?.price !== 0 && 
                            this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.tableInputs.priceType)?.priceDiscount > 0 ? [val => {
                        const material = this.myMaterials.find(c => c.id === this.tableInputs.materialId)
                        const priceForPriceType = material.prices.find(c => c.priceId === this.tableInputs.priceType)?.price
                        const discount = material?.prices.find(c => c.priceId === this.tableInputs.priceType)?.priceDiscount / 100 
                        return (priceForPriceType - (priceForPriceType * discount)) <= Number(val) && priceForPriceType >= Number(val)
                    }] : [],
					// || !this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.tableInputs.priceType)
					disableInput: this.tableInputs.freeSample || !this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.tableInputs.priceType) || this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.tableInputs.priceType).price === 0,
					sortable: false,
					width: this.entityTab !== 0 ? '6%' : 'auto',
					cellClass: 'px-1',
				}
				: null,

				addPrice && enableDiscount && this.entityTab !== 0 
                ? {
                    text: this.$t('headers.discount'),
                    name: 'priceDiscount',
                    value: 'priceDiscount',
                    disableInput: this.disabledDiscount,
					// inputRules: addPrice ? this.myMaterials.find(c => c.id === this.tableInputs.materialId) && this.myMaterials.find(c => c.id === this.tableInputs.materialId).prices.length !== 0 ? [val => 
                    //     val <= this.myMaterials.find(c => c.id === this.tableInputs.materialId).prices.find(c => c.priceId !== this.tableInputs.priceType)?.priceDiscount
                    // ] : [] : [],
					inputRules: [val => val <= (this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.find(c => c.priceId === this.tableInputs.priceType)?.priceDiscount) || val === 0],
					type: 'number'
                } 
                : null, 

				 	this.addPrice && this.entityTab !== 0 ? {
						text: this.$t('headers.payment-method'),
						name: 'payment',
						value: 'payment',
						setValueExpr: val => val ? this.paymentMethods.find(c => c.id === val)?.name : '-',
						sortable: false,
						width:  this.entityTab !== 0 ? '7%' : 'auto',
						cellClass: 'px-1',
					} : null,
                {
                    text: this.$t('headers.amount'),
                    name: 'amount',
                    value: 'amount',
					inputRules: this.isIntNumberRule ? rules.IntNumber : rules.requiredAsNumber,
                    type: 'number',
					sortable: false,
					width: this.entityTab !== 0 ? '5%' : '7%',
					cellClass: 'px-1',
                },
				// hide on addPrice because space
				this.entityTab !== 0 && !this.addPrice ? {
                    text: this.$t('headers.transaction-from-visit'),
                    name: 'notes',
                    value: 'notes',
					setValueExpr: val => val ? val.includes('Transaction from visit') : ' ',
                    type: 'string',
					noInput: true,
					sortable: false,
					cellClass: 'px-1',
					width: '15%'
                } : null,
				{
                    text: this.$t('headers.notes'),
                    name: 'description',
                    value: 'description',
					setValueExpr: val => val ? val.includes('Transaction from visit') ? '- ' : val : '-',
                    type: 'string',
					sortable: false,
					width: this.entityTab !== 0 ? '20%' : '40%',
					cellClass: 'px-1',
                },
				{	
                    text: this.$t('headers.deliver-date'),
                    name: 'date',
                    value: 'date',
					type: 'date',
					sortable: false,
					width: '17%',
					cellClass: 'px-0'
                },
				{
					text: '',
                    name: 'actions',
                    value: 'actions',
                    width: "auto",
                    noInput: true,
                    noNotAvailableText: true,
                    sortable: false,
					cellClass: 'px-1',
				}
            ]
			return headers.filter(c => Boolean(c))
        },

		allAccountsBrief() {
            return this.entityTab === 0 ? this.staff : this.customers;
        },

		currentUserData() {
            return this.staff.length
                ? this.staff.find(c => c.id === this.employeeId) || {}
                : {};
        },

        selectedAllCities () {
            return this.cityId.length === this.cities.length;
        },

        iconCities () {
            if (this.selectedAllCities) return 'mdi-close-box'
            return 'mdi-checkbox-blank-outline'
        },

		selectedAllRegions () {
            return this.regionIds.length === this.regionsAll.filter(c => this.cityId?.includes(c.cityId)).length;
        },

		icon () {
            if (this.selectedAllSectors) return 'mdi-close-box'
            if (this.selectedSomeSectors) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
    },

    methods: {
		search() {
			this.existType = true; 
			this.needToResetShownRows = true; 
			Promise.all([
				this.getJournal(null, true),
				// this.$store.dispatch('accounts/fetchAllBrief', {
				// 	regionIds: [],
				// 	type: this.entityTab,
				// 	entityTypeId: this.entity ? this.entity : null
				// })
			]).finally(() => {
				this.loading = false
			}).then((data) => {
	
                // this.briefAccounts[this.entityTab].push(...data[1]);
				// this.addTransactionToEntity = true
            })
		},
		editItem() {
			if (!this.$refs.form.validate()) return;
			this.submitLoading = true
			this.$store.dispatch('materialTransactions/update', {
				id: this.itemId,
				newSampleData: this.sampleData
			}).then(() => {
				this.dialog = false
				this.needToResetShownRows = true
				this.getJournal()
			}).finally(() => {
				this.submitLoading = false
			})
		},

		// getAllAccount(isFirstLoad) {
        //     if (this.allAccountsBrief.length && this.entityTab !== 1) return;
			
        //     this.loading = true;
        //     return this.$store.dispatch('accounts/fetchAllBrief', {
		// 		regionIds: [],
        //         type: this.entityTab,
		// 		entityType: this.entity ? this.entity : null
        //     }).then((data) => {
        //         this.briefAccounts[this.entityTab].push(...data);
		// 		if (this.entityTab === 0) {
		// 			this.staff = data
		// 		}
        //     }).finally(() => {
        //         if (!isFirstLoad) this.loading = false;
        //     })
        // },

		updateTableDueTab() {
			this.$router.replace({ name: 'journal-delivery-of-samples', query: { tab: this.entityTab } });
			this.$refs.table.resetShownRows();
			this.$refs.table.resetInputs({ date: moment().format('YYYY-MM-DD') });
			if (this.existType === false && this.entityTab !== 1) {
				this.updateJournal()
			}
        },
		
		async updateJournal(isFirstLoad = false) {
            this.loading = true;
            return Promise.all([
                // await this.getAllAccount(),
                this.getJournal(null, true),
            ]).catch(() => {
				this.loading = false;
			}).then(() => {
                // if (!isFirstLoad) 
				this.loading = false;
            });
        },

        addItem () {
			if (this.$refs.table.validate()) {
				this.loading = true
				var materials = {
					materialsAmount: {
						materialId: this.tableInputs.materialId,
						amount: this.tableInputs.amount,
						sellPrice: this.tableInputs.sellPrice ? this.tableInputs.sellPrice : 0,
						freeSample: this.tableInputs.freeSample ? this.tableInputs.freeSample : false,
						priceDiscount: this.tableInputs?.priceDiscount ? +this.tableInputs.priceDiscount : 0
					},
					fromAccountId: this.tab === 0 ? this.currentUserData.accountId : (this.entityTab !== 1 ? this.tableInputs.accountId : this.allAccountsBrief.find(c => c.name === this.tableInputs.accountId)?.accountId),
					toAccountId: this.tab === 0 ? (this.entityTab !== 1 ? this.tableInputs.accountId : this.allAccountsBrief.find(c => c.name === this.tableInputs.accountId)?.accountId) : this.currentUserData.accountId,
					date: this.tableInputs.date,
					description: this.tableInputs.description,
					payment: this.tableInputs.payment ? this.tableInputs.payment : 0,
					freeSample: this.tableInputs.freeSample
				}
				this.$store.dispatch('materialTransactions/createDeliverAndReceive', { materials }).then(async() => {
					this.needToResetShownRows = true;
					this.tableInputs.materialId = null;
					this.tableInputs.amount = null;
					this.$refs.table.resetInputs({
						date: moment().format('YYYY-MM-DD')
					})
					await this.updateJournal();
				}).catch((response) => {
					this.loading = false
				}).finally(() => {
					this.$refs.table.resetInputsFocus()
					this.tableInputs.date = moment().format('YYYY-MM-DD')
				})
			}
        },

		getJournal(newOptionsScroll, isFirstLoad = false) {
            let page = 1
            const { itemsPerPage } = this.scrollOptions;
            if (newOptionsScroll) page = newOptionsScroll.page || 1;
			if (this.needToResetShownRows) {
				this.needToResetShownRows = false;
				this.$refs.table.resetShownRows();
			}
            
            this.loading = true
			return this.$store.dispatch('materialTransactions/fetchStatement', {
                Date: this.date,
                Page: page,
                PerPage: itemsPerPage || 50,
                type: this.entityTab,
                WithVisitTransaction: null,
				SelectInAmount: this.entityTab === 0 && this.tab === 0,
				SelectOutAmount: this.entityTab === 0 && this.tab === 1,
				entityTypeId: this.entity,
				regionIds: this.regionIds 
            }).then(({ data, total }) => {
				const items = data.map(c => ({ 
                    ...c, 
                    amount: (c.in || c.out).amount,
	            	materialId: (c.in || c.out).materialId,
                    accountId: c.accountId,
                    notes: c.description,
                }));

                this.serverItemsLength = total;
				if (!this.existType && this.entityTab === 1) {
					return []
				} else {
					this.$refs.table.addScrollItems(items);
				}
			}).finally(() => {
                if (!isFirstLoad) this.loading = false;
            })
		},

		getAccount(item) {
			const accountName = this.allAccountsBrief.find(c => c.accountId === (
				this.entityTab === 0 && this.tab === 1
					? item.fromAccountId
					: item.accountId
				)
			)
			return accountName ? accountName.name : '-'
		},

		moment,

		setRegions () {
            this.regionIds = [];
            if (!this.cityId) return;
            this.regionsAll.forEach(region => {
                if (this.cityId.includes(region.cityId)) {
                    this.regionIds.push(region.id);
                }
            });
        },

		toggleCities () {
            this.$nextTick(() => {
                if (this.selectedAllCities) {
                    this.cityId = []
                    this.regionIds = []
                } 
                else {
                    this.cityId = this.cities.map(c => c.id);
                    this.setRegions()
                }
            })
        },

		toggleReignsFilterItems () {
            this.$nextTick(() => {
                if (this.selectedAllRegions) {
                    this.regionIds = []
                } else {
                    this.regionIds = this.regionsAll.filter(c => this.cityId.includes(c.cityId)).map(c => c.id);
                }
            })
        },

		resetFilter () {
			this.type = null
			this.cityId = []
			this.regionIds = []
			this.entity = null
		},

		getStatement () {
			this.needToResetShownRows = true
			this.updateJournal()
		},

		getMaterialByAccount () {
			let employeeId = null
			if (this.tab === 1) {
				employeeId = this.allAccountsBrief.find(c => c.accountId === this.tableInputs.accountId)?.id
				this.materialLoading = true
				this.$store.dispatch('materials/fetchMyMaterial', { 
					employeeId: employeeId, 
					withPrices: addPrice 
				}).finally(() => {
					this.materialLoading = false
				})
			}
		},
		getMaterialByAccountd () {
			this.materialLoading = true
		 	const employeeId = this.allAccountsBrief.find(c => c.accountId === this.employeeId)?.id
			this.$store.dispatch('materials/fetchMyMaterial', { 
				employeeId: employeeId,
				withPrices: addPrice 
			}).finally(() => {
				this.materialLoading = false
			})
		},

		resetInputsPrices () {
            if (this.addPrice && (!this.tableInputs.freeSample || this.tableInputs.freeSample === null)) {
                return [this.tableInputs.sellPrice, this.tableInputs.payment]
            } else {
                this.tableInputs.sellPrice = 0
				this.tableInputs.payment = null
                this.tableInputs.priceDiscount = 0
            }

            if (this.enablePricesTypes) {
                this.tableInputs.priceType = null
            }
        },

		changeOnChangeMaterial () {
            this.disabledDiscount = false
            if (addPrice && enablePricesTypes) {
                this.tableInputs.priceType = null
                this.tableInputs.sellPrice = 0
                this.tableInputs.priceDiscount = 0
                this.tableInputs.payment = null
                // if (this.myMaterials.find(c => c.id === this.tableInputs.materialId) &&
				// this.myMaterials.find(c => c.id === this.tableInputs.materialId).prices?.length === 0) {
                    // this.allMaterials.find(c => c.id === this.tableInputs.materialId)
                    // this.tableInputs.sellPrice = this.allMaterials.find(c => c.id === this.tableInputs.materialId).price
                // }
            } else {
				return null
			}
        },

		getPriceValue () {
			this.disabledDiscount = false
			this.tableInputs.sellPrice = 0
			this.tableInputs.priceDiscount = 0
            const material = this.myMaterials.find(c => c.id === this.tableInputs.materialId)
			if (material?.prices.length && material?.prices.find(c => c.priceId === this.tableInputs.priceType)?.price > 0) {
				this.tableInputs.sellPrice = material?.prices.find(v => v.priceId === this.tableInputs.priceType)?.price
			} else if (!material?.prices.length || material?.prices.find(c => c.priceId === this.tableInputs.priceType)?.price === 0 || (!material?.prices.find(c => c.priceId === this.tableInputs.priceType) || material?.prices.length < this.pricesTypes.length)) {
				this.dialogPriceType = true
            }
        },

		updatePrice () {
            const material = this.myMaterials.find(c => c.id === this.tableInputs.materialId)
            if (material.prices.length) {
                let priceFromApi = material.prices.find(c => c.priceId === this.tableInputs.priceType).price

                priceFromApi = priceFromApi - (+this.tableInputs.priceDiscount / 100) * priceFromApi
                
                this.tableInputs.sellPrice = priceFromApi
            } else {
                // fixed when add price to material mine endpoint and cancel fetchAll material endpoint from mounted hook
                const materialFromAllMaterial = this.allMaterials.find(c => c.id === this.tableInputs.materialId)
                this.tableInputs.sellPrice = materialFromAllMaterial.price - (+this.tableInputs.priceDiscount / 100) * (materialFromAllMaterial.price)
            }
        },

		updateX () {
			// if material have array prices 
            if (this.myMaterials.find(c => c.id === this.tableInputs.materialId).prices.length !== 0) {
				// sell price !== price from pricesTypes
                this.disabledDiscount = this.tableInputs.sellPrice !== this.myMaterials.find(c => c.id === this.tableInputs.materialId).prices.find(c => c.priceId === this.tableInputs.priceType).price
            } else if (this.customPrice && this.tableInputs.sellPrice !== this.allMaterials.find(c => c.id === this.tableInputs.materialId).price) {
                this.disabledDiscount = true
            } else {
                this.disabledDiscount = false
            }
        },

        saveDate (date) {
            this.$refs.dateInputTable.save(date)
        },

		updateItemPrice () {
            this.submitLoading = true
			const pricesMaterial = this.myMaterials.find(c => c.id === this.tableInputs.materialId)?.prices.map(c => ({ price: c.price, priceId: c.priceId, priceDiscountRate: c.priceDiscount }))

			if (pricesMaterial.find(c => c.priceId === this.tableInputs.priceType)?.price === 0) {
				pricesMaterial.find(c => c.priceId === this.tableInputs.priceType).price = this.price
				pricesMaterial.find(c => c.priceId === this.tableInputs.priceType).priceId = this.tableInputs.priceType
				pricesMaterial.find(c => c.priceId === this.tableInputs.priceType).priceDiscountRate = this.priceDiscountRate
			} 
			else if (!pricesMaterial.find(c => c.priceId === this.tableInputs.priceType)) {
				pricesMaterial.push({
					price: this.price,
					priceId: this.tableInputs.priceType,
					priceDiscountRate: this.priceDiscountRate
				})
			}
            // pricesMaterial.push({
            //     price: this.price,
            //     priceId: this.tableInputs.priceType,
            //     priceDiscountRate: this.priceDiscountRate
            // })
            this.$store.dispatch('materials/updatePrices', { 
                newPrices: pricesMaterial,
                id: this.tableInputs.materialId,
            }).then(() => {
				this.$store.dispatch('materials/fetchMyMaterial', { 
					employeeId: this.allAccountsBrief.find(c => c.accountId === this.tableInputs.accountId)?.id,
					withPrices: addPrice
				}).then(() => {
					this.getPriceValue()
					this.dialogPriceType = false
				})
            }).finally(() => {
                this.submitLoading = false
            })
        }

    },

    mounted () {
        this.loading = true;
		this.needToResetShownRows = true;
		this.entityTab = +this.$route.query.tab || 0;
		// this.$refs.table.resetInputs({ date: this.moment().format('YYYY-MM-DD') });
		this.tableInputs.date = moment().format('YYYY-MM-DD')

        Promise.all([
			this.$store.dispatch('materials/fetchMyMaterial', { 
				employeeId: this.allAccountsBrief.find(c => c.accountId === this.tableInputs.accountId)?.id,
				withPrices: addPrice
			}),
			this.enablePricesTypes ? this.$store.dispatch('pricesTypes/fetchAll') : null,
			// cancel when adding price to mine materials
            addPrice && enableDiscount ? this.$store.dispatch('materials/fetchByFilter', { }).then((data) => {
                this.allMaterials = data 
            }) : null,
			this.enableCustomerType && !this.customersTypes.length ? this.$store.dispatch('entityType/fetchAll') : null,
			// !this.staff.length ? this.$store.dispatch('accounts/fetchAllBrief', { type: 0, includeAddress: true, regionIds: [] }) : null,
        
			this.staff.length === 0 ? this.$requestStack.setRequest({
                key: 'accounts/fetchAllBrief/2',
                promise: this.$store.dispatch('accounts/fetchAllBrief', { type: 0, includeAddress: true, regionIds: [] }),
            }) : this.$requestStack.getRequest('accounts/fetchAllBrief/2').promise,

			this.customers.length === 0 ? this.$requestStack.setRequest({
                key: 'accounts/fetchAllBrief/1',
                promise: this.$store.dispatch('accounts/fetchAllBrief', { type: 1, includeAddress: true, regionIds: [] }),
            }) : this.$requestStack.getRequest('accounts/fetchAllBrief/1').promise,

		]).then(() => {
			this.$nextTick(() => {
				this.$refs.table.resetInputs({ date: this.moment().format('YYYY-MM-DD') })
			})
			if (this.entityTab !== 1) {
				this.updateJournal(true).finally(() => {
            		this.loading = false
        		})
			} else {
				this.loading = false
			}
		})
    }
}
</script>
<style scoped>
.paid-color-text {
    color: #f57f20
}
</style>
